module.exports = __webpack_public_path__ + "media/images/map_icons/RockClimbing-45d02aeb6642e60d577f1be66e4e960d.svg";